import { IAssessorReducer, IAssessorAction } from './interfaces';

const INITIAL_STATE: IAssessorReducer = {
  cooperativas: null,
  cooperativasIsLoading: false,
  parametrosIsLoading: false,
  quorumIsLoading: false,
  resultadoIsLoading: false,
  gerandoRelatorio: false,
  listaEventoIsLoading: false,
  statusForumIsChanging: false,
  pautasIsLoading: false,
  pautas: null,
  quantasVezesRecebemosPautasNovas: 0,
  liberandoResultadoPauta: false,
  procurandoAssociado: false,
  atualizandoAssociado: false,
  buscandoCadastros: false,
  buscandoContas: false,
};

export default function assessorReducer(
  state: IAssessorReducer = INITIAL_STATE,
  action: IAssessorAction
): IAssessorReducer {
  switch (action.type) {
    case 'setCooperativas':
      return { ...state, cooperativas: action.payload };
    case 'loadindCoopertaivas':
      return { ...state, cooperativasIsLoading: action.payload };
    case 'loadingParametros':
      return { ...state, parametrosIsLoading: action.payload };
    case 'loadingQuorum':
      return { ...state, quorumIsLoading: action.payload };
    case 'loadingResultado':
      return { ...state, resultadoIsLoading: action.payload };
    case 'loadingRelatorio':
      return { ...state, gerandoRelatorio: action.payload };
    case 'loadingListaEventos':
      return { ...state, listaEventoIsLoading: action.payload };
    case 'changingStatusForum':
      return { ...state, statusForumIsChanging: action.payload };
    case 'loadingPautas':
      return { ...state, pautasIsLoading: action.payload };
    case 'setPautas':
      return {
        ...state,
        pautas: action.payload,
        // quantasVezesRecebemosPautasNovas:
        //   state.quantasVezesRecebemosPautasNovas + 1,
      };
    case 'countRecebemosPautasNovas':
      return {
        ...state,
        quantasVezesRecebemosPautasNovas:
          state.quantasVezesRecebemosPautasNovas + 1,
      };
    case 'togglingResult':
      return { ...state, liberandoResultadoPauta: action.payload };
    case 'procurandoAssociado':
      return { ...state, procurandoAssociado: action.payload };
    case 'atualizandoAssociado':
      return { ...state, atualizandoAssociado: action.payload };
    case 'buscandoCadastros':
      return { ...state, buscandoCadastros: action.payload };
    case 'buscandoContas':
      return { ...state, buscandoContas: action.payload };
    default:
      return state;
  }
}
